export default "__VITE_PUBLIC_ASSET__57d7be6d__"